import { render, staticRenderFns } from "./reports-skill-signatures.vue?vue&type=template&id=35bbbf88"
import script from "./reports-skill-signatures.vue?vue&type=script&lang=js"
export * from "./reports-skill-signatures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports